// frontend/src/lib/homepageLogExcerpt.ts
//
// GENERATED — do not hand-edit. Refresh with:
//   node scripts/refresh_homepage_log_excerpt.mjs   (from frontend/)
//
// Verbatim slice of the live demo's flagged candidate plan log
// (job "terraform_plan: [data-platform]", pipeline 453520, trace 603732.txt —
// the run the homepage preview and /demo flag as Investigate). The homepage
// haystack strip renders it with real absolute line numbers, so the copy's
// claims (needle line, log length, corpus size) stay verifiably true to the
// shipped demo fixture.

/** 1-based line number (in the full log) of the first excerpt line. */
export const EXCERPT_START_LINE = 232;

/** 1-based line of the replace marker in the full log — the needle. */
export const NEEDLE_LINE = 267;

/** Total lines in this candidate plan log. */
export const CANDIDATE_LOG_LINES = 427;

/** Total log lines across the demo project's review window (30 traces). */
export const CORPUS_LOG_LINES = 6726;

/** Job whose log this is — matches the /demo comparison. */
export const CANDIDATE_JOB_LABEL = "terraform_plan: [data-platform]";

export const LOG_EXCERPT_LINES: readonly string[] = [
  "aws_secretsmanager_secret.pagerduty_token_replica: Refreshing state... [id=arn:aws:secretsmanager:us-east-1:842910557412:secret:pagerduty-token-replica-5a8995]",
  "aws_glue_catalog_database.marketing: Refreshing state... [id=marketing]",
  "aws_iam_role_policy.etl_runner_s3_core: Refreshing state... [id=etl-runner-s3-core:inline]",
  "aws_sqs_queue.notifications_shared: Refreshing state... [id=https://sqs.us-east-1.amazonaws.com/842910557412/acme-notifications-shared]",
  "aws_glue_job.sessionize_shared: Refreshing state... [id=sessionize-shared]",
  "aws_glue_job.revenue_rollup_staging: Refreshing state... [id=revenue-rollup-staging]",
  "aws_glue_catalog_database.billing: Refreshing state... [id=billing]",
  "aws_cloudwatch_log_group.etl_primary: Refreshing state... [id=/acme/etl-primary]",
  "aws_iam_role_policy.etl_runner_s3: Refreshing state... [id=etl-runner-s3:inline]",
  "aws_dynamodb_table.feature_flags_shared: Refreshing state... [id=acme-feature-flags-shared]",
  "aws_security_group.load_balancer_batch: Refreshing state... [id=sg-0e6c07de1ccdd5d43]",
  "aws_ssm_parameter.batch_window_replica: Refreshing state... [id=/acme/app-services/batch-window-replica]",
  "aws_security_group.internal_api_green: Refreshing state... [id=sg-0a70c65172435591e]",
  "aws_cloudwatch_log_group.api_gateway: Refreshing state... [id=/acme/api-gateway]",
  "aws_sqs_queue.webhook_retries_edge: Refreshing state... [id=https://sqs.us-east-1.amazonaws.com/842910557412/acme-webhook-retries-edge]",
  "aws_iam_role_policy.deploy_ecr_replica: Refreshing state... [id=deploy-ecr-replica:inline]",
  "aws_glue_catalog_database.billing_primary: Refreshing state... [id=billing-primary]",
  "aws_kinesis_stream.clickstream_core: Refreshing state... [id=acme-clickstream-core]",
  "aws_cloudwatch_log_group.airflow: Refreshing state... [id=/acme/airflow]",
  "aws_sns_topic.data_platform_pages_blue: Refreshing state... [id=arn:aws:sns:us-east-1:842910557412:acme-data-platform-pages-blue]",
  "aws_dynamodb_table.rate_limits: Refreshing state... [id=acme-rate-limits]",
  "aws_cloudwatch_log_group.worker: Refreshing state... [id=/acme/worker]",
  "aws_lambda_function.alert_forwarder_staging: Refreshing state... [id=alert-forwarder-staging]",
  "aws_dynamodb_table.feature_flags_primary: Refreshing state... [id=acme-feature-flags-primary]",
  "aws_iam_role.glue_crawler: Refreshing state... [id=glue-crawler]",
  "",
  "Terraform used the selected providers to generate the following execution",
  "plan. Resource actions are indicated with the following symbols:",
  "  -/+ destroy and then create replacement",
  "  - destroy",
  "  ~ update in-place",
  "  + create",
  "",
  "Terraform will perform the following actions:",
  "",
  "  # aws_rds_cluster.reporting must be replaced",
  '  -/+ resource "aws_rds_cluster" "reporting" {',
  '      ~ arn                 = "arn:aws:rds:us-east-1:842910557412:cluster:reporting" -> (known after apply)',
  '      ~ cluster_resource_id = "cluster-D85642F9611A" -> (known after apply)',
  '      ~ engine_version      = "14.9" -> "15.4"',
  '      ~ id                  = "reporting" -> (known after apply)',
  "      ~ storage_encrypted   = false -> true # forces replacement",
  "        # (29 unchanged attributes hidden)",
  "    }",
  "",
  "  # aws_db_instance.airflow_meta will be destroyed",
  '  - resource "aws_db_instance" "airflow_meta" {',
  '      - address                               = "airflow-meta.14d6b36f0507.us-east-1.rds.amazonaws.com" -> null',
  "      - allocated_storage                     = 100 -> null",
  '      - arn                                   = "arn:aws:rds:us-east-1:842910557412:db:airflow-meta" -> null',
  "      - auto_minor_version_upgrade            = true -> null",
  '      - availability_zone                     = "us-east-1a" -> null',
  "      - backup_retention_period               = 7 -> null",
  '      - backup_window                         = "06:00-06:30" -> null',
  '      - ca_cert_identifier                    = "rds-ca-rsa2048-g1" -> null',
  "      - copy_tags_to_snapshot                 = true -> null",
  '      - db_name                               = "airflow" -> null',
  '      - db_subnet_group_name                  = "data-private" -> null',
  "      - deletion_protection                   = false -> null",
  '      - endpoint                              = "airflow-meta.14d6b36f0507.us-east-1.rds.amazonaws.com:5432" -> null',
  '      - engine                                = "postgres" -> null',
  '      - engine_version                        = "13.13" -> null',
  '      - engine_version_actual                 = "13.13" -> null',
  '      - hosted_zone_id                        = "Z2R2ITUGPM61AM" -> null',
  '      - id                                    = "airflow-meta" -> null',
  '      - identifier                            = "airflow-meta" -> null',
  '      - instance_class                        = "db.m5.large" -> null',
  "      - iops                                  = 3000 -> null",
  '      - kms_key_id                            = "arn:aws:kms:us-east-1:842910557412:key/14d6b36f-14d6-4c1d-9e2a-14d6b36f0507" -> null',
  '      - maintenance_window                    = "mon:04:00-mon:04:30" -> null',
  "      - max_allocated_storage                 = 500 -> null",
  "      - monitoring_interval                   = 60 -> null",
  '      - monitoring_role_arn                   = "arn:aws:iam::842910557412:role/rds-monitoring-role" -> null',
  "      - multi_az                              = false -> null",
  '      - parameter_group_name                  = "pg-batch-tuning" -> null',
  "      - password                              = (sensitive value) -> null",
  "      - performance_insights_enabled          = true -> null",
  "      - performance_insights_retention_period = 7 -> null",
  "      - publicly_accessible                   = false -> null",
  '      - resource_id                           = "db-14D6B36F0507" -> null',
  "      - skip_final_snapshot                   = true -> null",
  '      - status                                = "available" -> null',
  "      - storage_encrypted                     = true -> null",
  "      - storage_throughput                    = 125 -> null",
  '      - storage_type                          = "gp3" -> null',
  "      - tags                                  = {",
  '          - "Environment" = "production"',
  '          - "ManagedBy"   = "terraform"',
  '          - "Team"        = "data-platform"',
  "        } -> null",
  "      - tags_all                              = {",
  '          - "Environment" = "production"',
  '          - "ManagedBy"   = "terraform"',
  '          - "Team"        = "data-platform"',
  "        } -> null",
  '      - username                              = "etl" -> null',
  "      - vpc_security_group_ids                = [",
  '          - "sg-0f31c8ab22e4d9d1c",',
  "        ] -> null",
  "    }",
  "",
  "  # aws_db_subnet_group.data_private will be destroyed",
  '  - resource "aws_db_subnet_group" "data_private" {',
  '      - arn                     = "arn:aws:rds:us-east-1:842910557412:subgrp:data-private" -> null',
  '      - description             = "Database subnets for the data platform" -> null',
  '      - id                      = "data-private" -> null',
  '      - name                    = "data-private" -> null',
  "      - subnet_ids              = [",
  '          - "subnet-08a1c9e2d4b6f3a71",',
  '          - "subnet-0b7d2f4a9c1e8d635",',
  '          - "subnet-03f6e8b1a5d9c2748",',
  "        ] -> null",
  "      - supported_network_types = [",
  '          - "IPV4",',
  "        ] -> null",
  "      - tags                    = {",
  '          - "Environment" = "production"',
  '          - "Team"        = "data-platform"',
  "        } -> null",
  "      - tags_all                = {",
  '          - "Environment" = "production"',
  '          - "Team"        = "data-platform"',
  "        } -> null",
  '      - vpc_id                  = "vpc-09944bae8980fd937" -> null',
  "    }",
  "",
  "  # aws_db_parameter_group.pg_batch_tuning will be updated in-place",
  '  ~ resource "aws_db_parameter_group" "pg_batch_tuning" {',
  '        id = "pg-batch-tuning"',
  "      ~ parameter {",
  '            apply_method = "pending-reboot"',
  '            name         = "max_connections"',
  '          ~ value        = "400" -> "800"',
  "        }",
  "      ~ parameter {",
  '            apply_method = "immediate"',
  '            name         = "work_mem"',
  '          ~ value        = "16384" -> "32768"',
  "        }",
  "        # (5 unchanged attributes hidden)",
  "    }",
  "",
  "  # aws_db_parameter_group.aurora_pg15_tuned will be updated in-place",
  '  ~ resource "aws_db_parameter_group" "aurora_pg15_tuned" {',
  '        id = "aurora-pg15-tuned"',
  "      ~ parameter {",
  '            apply_method = "pending-reboot"',
  '            name         = "max_connections"',
  '          ~ value        = "400" -> "800"',
  "        }",
  "      ~ parameter {",
  '            apply_method = "immediate"',
  '            name         = "work_mem"',
  '          ~ value        = "16384" -> "32768"',
  "        }",
  "        # (5 unchanged attributes hidden)",
  "    }",
  "",
  "  # aws_cloudwatch_metric_alarm.analytics_freeable_memory_replica will be created",
  '  + resource "aws_cloudwatch_metric_alarm" "analytics_freeable_memory_replica" {',
  "      + actions_enabled     = true",
  "      + alarm_actions       = [",
  '          + "arn:aws:sns:us-east-1:842910557412:data-platform-pages",',
  "        ]",
  '      + alarm_description   = "Freeable memory below safety threshold"',
  '      + alarm_name          = "analytics-freeable-memory-replica"',
  "      + arn                 = (known after apply)",
  '      + comparison_operator = "LessThanThreshold"',
  "      + datapoints_to_alarm = 3",
  "      + dimensions          = {",
  '          + "DBClusterIdentifier" = "analytics"',
  "        }",
  "      + evaluation_periods  = 3",
  "      + id                  = (known after apply)",
  '      + metric_name         = "FreeableMemory"',
  '      + namespace           = "AWS/RDS"',
  "      + ok_actions          = [",
  '          + "arn:aws:sns:us-east-1:842910557412:data-platform-pages",',
  "        ]",
  "      + period              = 300",
  '      + statistic           = "Average"',
  "      + tags_all            = {",
  '          + "Team" = "data-platform"',
  "        }",
  "      + threshold           = 2147483648",
  '      + treat_missing_data  = "missing"',
  "    }",
  "",
  "Plan: 2 to add, 2 to change, 3 to destroy.",
  "",
  "─────────────────────────────────────────────────────────────────────────────",
  "",
  "Saved the plan to: tfplan",
  "",
  "To perform exactly these actions, run the following command to apply:",
  '    terraform apply "tfplan"',
];
